module.exports = __webpack_public_path__ + "img/before-1.695641e3.png";